<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <v-card-title class="elevation-0">
          <!-- <span class="itemHeading">Apply for loan</span> -->
          <v-spacer></v-spacer>
        </v-card-title>
        <v-layout wrap justify-start>
          <v-flex xs12 align-self-center fill-height pa-0>
            <v-card tile flat>
              <v-form v-model="addcat2" ref="addcat2">
                <v-layout wrap v-if="appUser">
                  <v-flex
                    xs12
                    sm6
                    align-self-center
                    text-left
                    pa-2
                    v-if="appUser.name"
                  >
                    <v-text-field
                      v-model="appUser.name"
                      label="Name"
                      :rules="[rules.required]"
                      required
                      disabled
                      hide-details
                      outlined
                      type="text"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 align-self-center text-left pa-2>
                    <v-text-field
                      v-model="appUser.positionid[0].name"
                      label="Designation"
                      :rules="[rules.required]"
                      required
                      hide-details
                      readonly
                      outlined
                      type="text"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 align-self-center text-left pa-2>
                    <v-text-field
                      v-model="appUser.grade"
                      label="Grade"
                      :rules="[rules.required]"
                      required
                      hide-details
                      readonly
                      outlined
                      type="text"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 align-self-center text-left pa-2>
                    <v-text-field
                      v-model="programmeOrDivision"
                      label="Programme/ Division"
                      :rules="[rules.required]"
                      required
                      hide-details
                      outlined
                      type="text"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 align-self-center text-left pa-2>
                    <v-text-field
                      v-model="office"
                      label="Office"
                      :rules="[rules.required]"
                      required
                      hide-details
                      outlined
                      type="text"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 align-self-center text-left pa-2>
                    <v-text-field
                      v-model="loanAmount"
                      label="Loan amount"
                      :rules="[rules.required]"
                      required
                      hide-details
                      outlined
                      type="number"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 align-self-center text-left pa-2>
                    <v-text-field
                      v-model="tobeReleasedBy"
                      label="To be released by"
                      :rules="[rules.required]"
                      required
                      hide-details
                      readonly
                      outlined
                      type="text"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    align-self-center
                    text-left
                    pa-2
                    v-if="userJoinDate"
                  >
                    <v-text-field
                      :value="formatDateonly(userJoinDate)"
                      label="Date of Joining WTI"
                      :rules="[rules.required]"
                      required
                      disabled
                      hide-details
                      outlined
                      type="text"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 align-self-center text-left pa-2>
                    <v-text-field
                      v-model="presentNetSalaryPerMonth"
                      label="Present net salary/ month"
                      :rules="[rules.required]"
                      required
                      hide-details
                      disabled
                      outlined
                      type="number"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 pa-2>
                    <v-text-field
                      v-model="purposeOfLoan"
                      label="Purpose of loan"
                      hide-details
                      outlined
                      type="type"
                      @wheel="$event.target.blur()"
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 pa-2 align-self-start>
                    <v-layout wrap>
                      <v-flex xs12 align-self-center text-left pa-2>
                        <span
                          >As on date, iIs there any advance/ loan amount
                          outstanding against you?</span
                        >
                      </v-flex>
                      <v-flex xs12 align-self-center text-left pa-2>
                        <v-radio-group v-model="radios" row hide-details>
                          <v-radio label="Yes" value="true"></v-radio>
                          <v-radio label="No" value="false"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex
                        xs12
                        sm4
                        align-self-center
                        text-left
                        pa-2
                        v-if="radios == 'true'"
                      >
                        <v-text-field
                          v-model="advanceLoanAmount"
                          label="Enter Amount"
                          hide-details
                          outlined
                          type="number"
                          @wheel="$event.target.blur()"
                          dense
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 pa-2>
                    <v-layout wrap justify-start>
                      <v-flex xs12 text-left>
                        <span> Supporting Document </span>
                      </v-flex>
                      <v-flex
                        xs11
                        sm11
                        md11
                        lg11
                        pa-8
                        align-self-center
                        text-center
                        style="
                          border-style: dotted;
                          border-color: #3574c6;
                          border-radius: 5px;
                          cursor: pointer;
                          background-color: white;
                        "
                        @click="$refs.fileInput.click()"
                      >
                        <v-layout wrap justify-center pt-0>
                          <v-flex xs12 sm12 md12 lg12>
                            <v-layout wrap justify-center>
                              <v-flex
                                xs12
                                sm4
                                md3
                                lg2
                                text-center
                                align-self-center
                                fill-height
                              >
                                <v-img
                                  src="@/assets/images/upload.png"
                                  contain
                                  height="50px"
                                  alt="upload"
                                  width="100px"
                                ></v-img>
                              </v-flex>
                              <v-flex xs12 text-center>
                                <span
                                  style="
                                    font-size: 16px;
                                    font-weight: 600;
                                    color: #676767;
                                  "
                                >
                                  {{
                                    selectedFileName ||
                                    "Click to upload supporting document"
                                  }}
                                </span>
                              </v-flex>
                            </v-layout>
                            <input
                              ref="fileInput"
                              v-show="false"
                              type="file"
                              @change="handleFileUpload"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 pa-2>
                    <v-layout wrap justify-start>
                      <v-flex xs12 text-left>
                        <span>
                          Signature or Thumb impression of the Applicant
                        </span>
                      </v-flex>
                      <v-flex
                        xs11
                        sm11
                        md11
                        lg11
                        pa-8
                        align-self-center
                        text-center
                        style="
                          border-style: dotted;
                          border-color: #3574c6;
                          border-radius: 5px;
                          cursor: pointer;
                          background-color: white;
                        "
                        @click="$refs.signatureInput.click()"
                      >
                        <v-layout wrap justify-center pt-0>
                          <v-flex xs12 sm12 md12 lg12>
                            <v-layout wrap justify-center>
                              <v-flex
                                xs12
                                sm4
                                md3
                                lg2
                                text-center
                                align-self-center
                                fill-height
                              >
                                <v-img
                                  src="@/assets/images/upload.png"
                                  contain
                                  height="50px"
                                  alt="upload"
                                  width="100px"
                                ></v-img>
                              </v-flex>
                              <v-flex xs12 text-center>
                                <span
                                  style="
                                    font-size: 16px;
                                    font-weight: 600;
                                    color: #676767;
                                  "
                                >
                                  {{
                                    signatureFileName ||
                                    "Click to upload signature or thump impression"
                                  }}
                                </span>
                              </v-flex>
                            </v-layout>
                            <input
                              ref="signatureInput"
                              v-show="false"
                              type="file"
                              accept="image/*,.pdf"
                              @change="handleSignatureUpload"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 align-self-center text-center pa-2>
                    <v-layout wrap justify-center py-4>
                      <v-flex xs12 sm6 md4 lg3 align-self-center px-4>
                        <v-btn
                          color="#005f32"
                          dark
                          tile
                          large
                          class="rounded-xl"
                          block
                          @click="applyLoan()"
                        >
                          Submit
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- </v-card> -->
      </v-flex>
    </v-layout>
    <v-dialog persistent v-model="confirmDialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            align-self-center
            pa-4
            style="background: #005f32"
            text-left
          >
            <span class="kumbhBold" style="color: #ffffff"
              >Confirmation Required</span
            >
          </v-flex>
        </v-layout>
        <v-layout wrap pa-6>
          <v-flex xs12 align-self-end pa-3>
            <span class="kumbhMedium"
              >The loan amount you entered is more than
              {{ ctcMultiplier }} times your monthly CTC (₹{{
                maxAllowedAmount
              }}). Are you sure you want to proceed?</span
            >
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" tile dark @click="cancelHighAmount"
            >Cancel</v-btn
          >
          &nbsp;
          <v-btn color="#005f32" outlined tile @click="proceedWithHighAmount"
            >Proceed</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="maxLimitDialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            align-self-center
            pa-4
            style="background: #005f32"
            text-left
          >
            <span class="kumbhBold" style="color: #ffffff"
              >Maximum Limit Exceeded</span
            >
          </v-flex>
        </v-layout>
        <v-layout wrap pa-6>
          <v-flex xs12 align-self-end pa-3>
            <span class="kumbhMedium"
              >The maximum loan amount allowed is ₹1,00,000 (One Lakh). Please
              enter an amount within this limit.</span
            >
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" tile dark @click="closeMaxLimitDialog">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      chip: true,
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      pageCount: 1,
      appLoading: false,
      joindate: null,
      //add
      name: null,
      designation: null,
      grade: null,
      programmeOrDivision: null,
      office: null,
      loanAmount: null,
      tobeReleasedBy: "Finance",
      //fileupload
      documentFile1: [],
      docsdata: new FormData(),

      // dateOfJoining:null,
      // advanceLoanAmountExist: false,
      advanceLoanAmount: 0,
      purposeOfLoan: null,
      //
      addcat: false,
      addcat2: false,
      rules: {
        required: (value) => !!value || "Required.",
      },

      // typeList: ["Salary Advance", "Loan"],
      amount: null,
      radios: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      selectedFileName: null,
      selectedFile: null,
      signatureFileName: null,
      signatureFile: null,
      confirmDialog: false,
      maxLimitDialog: false,
      ctcMultiplier: 3,
      maxLoanLimit: 100000,
    };
  },
  watch: {
    radios(newValue) {
      // If changed to 'no', clear the advance loan amount
      if (newValue === "false") {
        this.advanceLoanAmount = 0;
      }
    },
  },
  mounted() {
    //  if(this.appUser.name!='Super Admin')
    // this.joindate = this.appUser.dateofjoining.slice(0,10)
  },
  computed: {
    currentFinancialYear() {
      const today = new Date();
      const month = today.getMonth(); // 0-11
      const year = today.getFullYear();

      if (month >= 3) {
        // After March (April onwards)
        return `${year}-${year + 1}`;
      } else {
        // January to March
        return `${year - 1}-${year}`;
      }
    },
    maxAllowedAmount() {
      return this.$store.state.userData.monthlyCTC * this.ctcMultiplier;
    },
    appUser() {
      return this.$store.state.userData;
    },
    userJoinDate() {
      return this.$store.state.userData.dateofjoining;
    },
    userId() {
      return this.$store.state.userData._id;
    },
    presentNetSalaryPerMonth() {
      return this.$store.state.userData.monthlyCTC;
    },
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.selectedFileName = file.name;

        // If you still need to use documentFile1 array for your backend
        this.documentFile1 = [file];
      }
    },
    formatDateonly(date) {
      if (!date) return "";
      const d = new Date(date);
      if (isNaN(d)) {
        console.error("Invalid date:", date);
        return "";
      }
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
    },
    handleSignatureUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.signatureFile = file;
        this.signatureFileName = file.name;
      }
    },
    close(item, i) {
      this.documentFile1.splice(i, 1);
    },
    validateInput() {
      if (!this.type) {
        this.msg = "Please choose type";
        this.showsnackbar = true;
        return;
      } else if (!this.amount) {
        this.msg = "Please provide amount";
        this.showsnackbar = true;
        return;
      } else {
        this.applyLoan();
      }
    },
    browseCover(event) {
      var got = event.target.files;
      if (got.length < 5) {
        for (let i = 0; i < got.length; i++) {
          this.documentFile1.push(got[i]);
        }
        console.log("file isss", this.documentFile1);
      } else {
        this.msg = "Maximum 3 can be uploaded";
        this.showSnackBar = true;
      }
    },
    docsupload() {
      if (!this.selectedFile && !this.signatureFile) return;

      this.docsdata = new FormData();

      if (this.selectedFile) {
        this.docsdata.append("document", this.selectedFile);
      }

      if (this.signatureFile) {
        this.docsdata.append("signature", this.signatureFile);
      }

      this.docsdata.append("id", this.documentID);

      this.appLoading = true;
      axios({
        url: "/upload/loandocuments",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.docsdata,
      })
        .then((response) => {
          this.appLoading = false;
          this.selectedFile = null;
          this.selectedFileName = null;
          this.signatureFile = null;
          this.signatureFileName = null;
          this.documentFile1 = [];
          this.docsdata = new FormData();
          this.msg = response.data.msg;
          this.$router.push("/MyLoanApplications");
          this.clearOff();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    applyLoan() {
      if (this.radios === "true" && !this.advanceLoanAmount) {
        this.msg = "Please enter the existing advance/loan amount";
        this.showsnackbar = true;
        return;
      }
      // First check if amount exceeds 1 lakh
      if (this.loanAmount > this.maxLoanLimit) {
        this.maxLimitDialog = true;
        return;
      }
      // Then check if amount exceeds 3x monthlyCTC
      if (this.loanAmount > this.maxAllowedAmount) {
        this.confirmDialog = true;
        return;
      }

      this.proceedWithLoanApplication();
    },
    closeMaxLimitDialog() {
      this.maxLimitDialog = false;
      this.loanAmount = null;
    },
    proceedWithLoanApplication() {
      const formData = new FormData();

      // Append all form fields
      formData.append("employeeId", this.userId);
      formData.append("name", this.appUser.name);
      formData.append("designation", this.appUser.positionid[0].name);
      formData.append("grade", this.appUser.grade);
      formData.append("programmeOrDivision", this.programmeOrDivision);
      formData.append("office", this.office);
      formData.append("loanAmount", this.loanAmount);
      formData.append("tobeReleasedBy", this.tobeReleasedBy);
      formData.append("dateOfJoining", this.userJoinDate);
      formData.append(
        "presentNetSalaryPerMonth",
        this.presentNetSalaryPerMonth
      );
      formData.append("advanceLoanAmountExist", this.radios);
      formData.append("advanceLoanAmount", this.advanceLoanAmount);
      formData.append("purposeOfLoan", this.purposeOfLoan);

      // Append files
      formData.append("supportDoc", this.selectedFile);
      formData.append("empSign", this.signatureFile);
      formData.append("fyear", this.currentFinancialYear);

      this.appLoading = true;
      axios({
        url: "/employee/loan/add",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.$router.push("/MyLoanApplications");

            // Clear the form
            this.selectedFile = null;
            this.selectedFileName = null;
            this.signatureFile = null;
            this.signatureFileName = null;
            this.documentFile1 = [];
            this.clearOff();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    cancelHighAmount() {
      this.confirmDialog = false;
      this.loanAmount = null;
    },
    proceedWithHighAmount() {
      this.confirmDialog = false;
      this.proceedWithLoanApplication();
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " , " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;

      return strTime;
    },
    clearOff() {
      this.type = null;
      this.amount = null;
      this.description = null;
    },
  },
};
</script>
